import { Slide } from '@/components/core/Slide';
import audioFile from './20-masters-intro.mp3';

const transcript = `
  Ja… laten we beginnen met de opdracht voor Masters. Ik neem de vrijheid om het publiek in de zaal uit te 
  leggen hoe je normaal gesproken te werk gaat, als je dat goed vindt?
`;

// Nee dat vind ik niet goed.
// het mag een toontje lager, zoals we hadden afgesproken.
// Ok, Masters is dus een magazine waar ik rgelmatig synthografie opdarchten voor maak.

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="full">
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
